import { Routes } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { mpsRouteNames } from '../mps-route-names';
import { applicationRouteNames } from '../../app/application-route-names';

// Blank component for OAuth2 token callback handling
// The mpsFetchBearer initializer handles the token exchange before routing
// This component just redirects to home after token is processed
@Component({
  selector: 'mps-oauth2-callback',
  template: '<div>Processing authentication...</div>',
  standalone: true,
})
export class MpsOauth2CallbackComponent implements OnInit {
  private router = inject(Router);

  ngOnInit(): void {
    // The initializer has already processed the token by this point
    // Now redirect to the monitoring page (home was removed)
    this.router.navigate([`${mpsRouteNames.root + applicationRouteNames.monitoring}`]);
  }
}

export const mpsCoreRoutes: Routes = [
  {
    path: 'oauth2/token',
    component: MpsOauth2CallbackComponent,
  },
];
